import {
  IconShieldLock,
  IconClipboardList,
  IconSettings,
  IconHierarchy2,
} from "@tabler/icons";

const icons = {
  IconShieldLock,
  IconClipboardList,
  IconSettings,
  IconHierarchy2,
};

const adminMenu = {
  id: "administration",
  title: "ผู้ดูแลระบบ",
  type: "group",
  roles: ["superadmin"],
  children: [
    {
      id: "admin-directory",
      title: "รายชื่อผู้ดูแล",
      type: "item",
      url: "/admins",
      icon: icons.IconShieldLock,
      breadcrumbs: true,
      roles: ["superadmin"],
    },
    {
      id: "audit-logs",
      title: "บันทึกการใช้งาน",
      type: "item",
      url: "/audit-logs",
      icon: icons.IconClipboardList,
      breadcrumbs: true,
      roles: ["superadmin"],
    },
    {
      id: "menu-permissions",
      title: "สิทธิ์การเข้าเมนู",
      type: "item",
      url: "/menu-permissions",
      icon: icons.IconSettings,
      breadcrumbs: true,
      roles: ["superadmin"],
    },
    {
      id: "feature-flags",
      title: "ฟีเจอร์แฟล็ก",
      type: "item",
      url: "/feature-flags",
      icon: icons.IconSettings,
      breadcrumbs: true,
      roles: ["superadmin"],
    },
    {
      id: "role-templates",
      title: "เทมเพลตบทบาท",
      type: "item",
      url: "/role-templates",
      icon: icons.IconHierarchy2,
      breadcrumbs: true,
      roles: ["superadmin"],
    },
  ],
};

export default adminMenu;
